import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/AboutUs',
    name: 'AboutUs',
    component: () => import('@/views/AboutUs.vue'),
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/ExcellentCase',
    name: 'ExcellentCase',
    component: () => import('@/views/ExcellentCase.vue'),
    meta: {
      title: '优秀案例'
    }
  },
  {
    path: '/InnovationList',
    name: 'InnovationList',
    component: () => import('@/views/InnovationList.vue'),
    meta: {
      title: '创新中心'
    }
  },
  {
    path: '/InnovationCenter',
    name: 'InnovationCenter',
    component: () => import('@/views/InnovationCenter.vue'),
    meta: {
      title: '创新中心'
    }
  },
  {
    path: '/partners',
    name: 'partners',
    component: () => import('@/views/partners.vue'),
    meta: {
      title: '合作院校'
    }
  },
  {
    path: '/PolicyPaper',
    name: 'PolicyPaper',
    component: () => import('@/views/PolicyPaper.vue'),
    meta: {
      title: '政策文件'
    }
  },
  {
    path: '/PolicyPaperDetails',
    name: 'PolicyPaperDetails',
    component: () => import('@/views/PolicyPaper-details.vue'),
    meta: {
      title: '文章详情'
    }
  },
  {
    path: '/ExcellentCaseList',
    name: 'ExcellentCaseList',
    component: () => import('@/views/ExcellentCaseList.vue'),
    meta: {
      title: '优秀案例'
    }
  },
  {
    path: '/ExcellentCaseDetail',
    name: 'ExcellentCaseDetail',
    component: () => import('@/views/ExcellentCaseDetail.vue'),
    meta: {
      title: '优秀案例'
    }
  },
  {
    path: '/live',
    name: 'live',
    component: () => import('@/views/live.vue'),
    meta: {
      title: '直播预告'
    }
  },
  {
    path: '/live-details',
    name: 'live-details',
    component: () => import('@/views/live-details.vue'),
    meta: {
      title: '直播预告'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 新增导航守卫，用于在路由变化时更新网页标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  window.scrollTo(0, 0)
  next()
})

export default router
